// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rnBv","right":"Footer_right__3R46W","buttons":"Footer_buttons__3T0aA"};